import { PopoverForOverflownText } from '@lifebit-ai/lds'
import React from 'react'

import { Unassigned } from 'modules/requests/ExportAndAccessRequestsTable/RequestsTable.styles'

interface AssigneeColumnContentProps {
  assignedTo?: { name?: string; email: string }
}

/**
 * Shared table-cell renderer for a request assignee. Prefers the human-readable name,
 * falling back to email when the user has no name set, and shows "Unassigned" when empty.
 * Used by both the export/access and import request tables.
 */
export const AssigneeColumnContent = ({ assignedTo }: AssigneeColumnContentProps) => {
  if (!assignedTo) {
    return <Unassigned>Unassigned</Unassigned>
  }

  const displayName = assignedTo.name ?? assignedTo.email

  return <PopoverForOverflownText title={displayName}>{displayName}</PopoverForOverflownText>
}
